module.exports = __webpack_public_path__ + "static/media/89 - Alain Chamfort - Bambou (Pilooski _ Jayvich Reprise).e52b3933.mp3";